module.exports = __webpack_public_path__ + "images/stickers/taco-celebrate.20b0c2f6c78ca34d7c3d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-celebrate.png
// module id = 0UAS
// module chunks = 1